module.exports = __webpack_public_path__ + "static/media/standard.d9430fbb.svg";